import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CommissionSummariesService {
  constructor(private http: HttpClientService) {}

  public post(commission_summary): Observable<any> {
    return this.http
      .post("/api/commission_summaries", commission_summary)
      .pipe(tap((_) => console.log("CommissionSummaryService.post: Ok.")));
  }

  public updateCommissionSummary(id, data): Observable<any> {
    return this.http
      .put("/api/commission_summaries/" + id, data)
      .pipe(tap((_) => console.log("CommissionSummaryService.update: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/commission_summaries/" + id)
      .pipe(tap((_) => console.log("CommissionSummaryService.delete: Ok.")));
  }
}
